import React, { useEffect } from "react";
import useStyles from "./Styles";
import {
  IconButton,
  Grid,
  Box,
  Tabs,
  Tab,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
// import Metrics from "./Metrics";

const AboutSidebar = (props) => {
  const classes = useStyles();
  const { onClose, MetricsComponent, about } = props;
  const [tab, setTab] = React.useState("stats");

  useEffect(() => {
    if (MetricsComponent===undefined) {
      setTab("about");
    }
  }, [MetricsComponent]);

  const onChangeTab = (event, value) => {
    setTab(value);
  };

  return (
    <Box p={4} pt={1}>
      <IconButton className={classes.closeBtn} onClick={onClose}>
        <CloseIcon />
      </IconButton>
      {MetricsComponent &&
        <Grid item xs={12} className={classes.tabs}>
          <Tabs
            value={tab}
            onChange={onChangeTab}
            classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
          >
            <Tab
              classes={{ root: classes.tabInactive, selected: classes.tabActive }}
              value="about"
              label="Summary"
              className={classes.startingTab}
            ></Tab>
            <Tab
              classes={{ root: classes.tabInactive, selected: classes.tabActive }}
              value="stats"
              label="Stats"
              className={classes.endingTab}
            ></Tab>
          </Tabs>
        </Grid>
      }
      
      {tab === "about" ? (
        <Grid item xs={12} className={classes.aboutBox}>
            <Typography
              variant="h6"
              component="div"
              className={classes.sectionTitle}
            >
              {about.title}
            </Typography>
          <Typography
            variant="body2"
            component="p"
            className={classes.sectionContent}
          >
            {about.desc}
          </Typography>
          {/*
            <Typography variant="h6" component="div" className={classes.sectionTitle}>
                About the Big River Policy
            </Typography>
            <Typography variant="body2" component="p" className={classes.sectionContent}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip ex ea com duis aute irure. <br/><br/> Learn More about this Big River Policy at the Kyl Center website.
            </Typography>   
        */}
        </Grid>
      ) : (
        MetricsComponent
      )}
    </Box>
  );
};

export default AboutSidebar;
